"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldsQueryGrid = exports.mapResultNode = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FlowFieldsDisplayGrid_1 = require("./FlowFieldsDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.flows && resultData.flows[0]
        && resultData.flows[0].outputSteps[0] && resultData.flows[0].outputSteps[0].outputFieldsConnection;
}
function mapResultNode(_a, resultData) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var { id, name } = _a, node = tslib_1.__rest(_a, ["id", "name"]);
    const rest = {
        flowVizportalUrlId: (_b = resultData.flows[0]) === null || _b === void 0 ? void 0 : _b.vizportalUrlId,
        id,
        name,
        fieldIcon: null,
        sheetCount: null,
        typeName: node.__typename,
    };
    switch (node.__typename) {
        case 'FlowFieldOutputField':
            return Object.assign(Object.assign({}, rest), { fieldIcon: (0, FieldFunctions_1.iconForField)(node.field), sheetCount: (_e = (_d = (_c = node.field) === null || _c === void 0 ? void 0 : _c.downstreamSheetsConnection) === null || _d === void 0 ? void 0 : _d.totalCount) !== null && _e !== void 0 ? _e : null, labels: ((_f = node.field) === null || _f === void 0 ? void 0 : _f.__typename) === 'ColumnField'
                    ? (_g = node.field.columnsConnection) === null || _g === void 0 ? void 0 : _g.nodes.flatMap(t => t.labels)
                    : [] });
        case 'FlowColumnOutputField':
            return Object.assign(Object.assign({}, rest), { remoteType: (_j = (_h = node.column) === null || _h === void 0 ? void 0 : _h.remoteType) !== null && _j !== void 0 ? _j : undefined, sheetCount: (_m = (_l = (_k = node.column) === null || _k === void 0 ? void 0 : _k.downstreamSheetsConnection) === null || _l === void 0 ? void 0 : _l.totalCount) !== null && _m !== void 0 ? _m : null, labels: ((_o = node.column) === null || _o === void 0 ? void 0 : _o.labels)
                    ? (_q = (_p = node.column) === null || _p === void 0 ? void 0 : _p.upstreamColumns) === null || _q === void 0 ? void 0 : _q.flatMap(c => c ? c.labels : []).concat((_r = node.column) === null || _r === void 0 ? void 0 : _r.labels)
                    : (_t = (_s = node.column) === null || _s === void 0 ? void 0 : _s.upstreamColumns) === null || _t === void 0 ? void 0 : _t.flatMap(c => c ? c.labels : []) });
        default:
            (0, vizportalclient_common_components_1.assertUnreachable)(node);
            return Object.assign(Object.assign({}, rest), { fieldIcon: null, sheetCount: null });
    }
}
exports.mapResultNode = mapResultNode;
function FlowFieldsQueryGrid(props) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.FlowFieldsByIdDocument, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            selectedOutputStepId: props.selectedOutputStepId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(FlowFieldsDisplayGrid_1.FlowFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))));
}
exports.FlowFieldsQueryGrid = FlowFieldsQueryGrid;
//# sourceMappingURL=FlowFieldsQueryGrid.js.map